<template>
  <v-data-table
    dense
    :headers="headers"
    :items="displayItems"
    :loading="loading"
    class="modern-table elevation-0"
    :items-per-page="5"
    :footer-props="{
      itemsPerPageOptions: [5, 10, 20]
    }"
  >
    <template v-slot:top>
      <div class="px-4 py-2 d-flex justify-end bg-light border-bottom">
        <contact-create-update-2 :action="'create'" @created="fetch" :customerId="customerId"/>
      </div>
    </template>

    <template v-slot:item.name="{ item }">
      <div class="d-flex align-center py-1">
        <v-avatar size="24" color="primary lighten-4" class="mr-2">
          <span class="primary--text caption font-weight-bold">{{ item.first_name[0] }}{{ item.last_name[0] }}</span>
        </v-avatar>
        <span class="body-2 font-weight-medium">{{ item.first_name }} {{ item.last_name }}</span>
      </div>
    </template>

    <template v-slot:item.email="{ item }">
      <div class="d-flex align-center grey--text text--darken-2">
        <v-icon x-small class="mr-1">fas fa-envelope</v-icon>
        <span class="caption">{{ item.email }}</span>
      </div>
    </template>

    <template v-slot:item.phone="{ item }">
      <div class="d-flex align-center grey--text text--darken-2">
        <v-icon x-small class="mr-1">fas fa-phone</v-icon>
        <span class="caption">{{ item.phone }}</span>
      </div>
    </template>

    <template v-slot:item.cargo="{ item }">
      <v-chip x-small label outlined color="grey lighten-1">{{ item.cargo || 'Sin cargo' }}</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <contact-create-update-2 :action="'edit'" v-model="item" @updated="fetch" @deleted="fetch" :customerId="customerId"/>
    </template>
  </v-data-table>
</template>

<script>
import ContactCreateUpdate2 from './ContactCreateUpdate2.vue';
import { fetchContacts } from '@/api/customers';
import notifications from '@/utils/notifications';

export default {
  name: 'ContactList',
  components: {
    ContactCreateUpdate2
  },
  props: {
    value: Array,
    customerId: {
      type: Number,
      required: false,
    },
    embeded: {
      type: Boolean,
      default: true
    },
    skipFirst: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayItems() {
      if (!this.value) return []
      return this.skipFirst ? this.value.slice(1) : this.value
    }
  },
  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'name', align: 'start' },
        { text: 'Correo', value: 'email', align: 'start' },
        { text: 'Teléfono', value: 'phone', align: 'start' },
        { text: 'Cargo', value: 'cargo', align: 'start' },
        { text: '', value: 'actions', sortable: false, align: 'end', width: '60' }
      ],
      loading: false
    };
  },
  methods: {
    fetch() {
      if (!this.customerId) return;
      this.loading = true;
      const query = `?customer=${this.customerId}`;
      fetchContacts(query)
      .then(response => {
        this.$emit('input', response);
      })
      .catch(error => {
        notifications.showError('Error cargando contactos: ' + error)
      })
      .finally(() => {
        this.loading = false;
      })
    },
  }
};
</script>

<style scoped>
.modern-table {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 8px !important;
}
.bg-light { background-color: #fcfcfc; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05); }
</style>